module.exports = require("./zh-Hans.d.ts");